// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { SCREEN_FILTER_CODE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
} from "constants/FormatDataContanst";
import { TYPE_INVOICE_POS_ANOTHER } from "constants/InvoicePosConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { getResourceIdXML } from "helpers/form_helper";
import { checkIsHaveInvoicePos } from "helpers/utils";
import { useGetFilter } from "hook/invoices/useFilterByUser";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import {
  downloadXmlInvoicePos,
  listPhaseInvoicePos,
  resetDownloadXmlInvoicePos,
  resetListPhaseInvoicePos,
  setListPhaseInvoicePosColumn,
} from "store/actions";
import {
  DOWNLOAD_XML_INVOICE_POS_FAIL,
  DOWNLOAD_XML_INVOICE_POS_SUCCESS,
} from "store/invoice-pos/actionTypes";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { formatHiddenColumn, getPhaseInvoicePosStatus } from "../utils";
import DetailPhaseInvoicePos from "./DetailPhaseInvoicePos";

const ListPhaseInvoicePos = props => {
  const location = useLocation();
  // Parse the query parameters
  const queryParams = new URLSearchParams(location.search);
  const filterId = queryParams.get("filterId");

  const [isUIRender, setIsUIRender] = useState(true);
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => {
    if (modalDetail) {
      resetDataFunc();
    }
    setModalDetail(!modalDetail);
  };
  // modalErrorRelease
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // Confirm Release modal
  const [modalConfirmRelease, setModalConfirmRelease] = useState(false);
  const toggleConfirmReleaseModal = () =>
    setModalConfirmRelease(!modalConfirmRelease);
  const [idRelease, setIdRelease] = useState(null);

  const [modalUploadFile, setModalUploadFile] = useState(false);
  const toggleUploadFileModal = () => setModalUploadFile(!modalUploadFile);

  // Button download template
  const [isOpenDownloadTemplate, setIsOpenDownloadTemplate] = useState(false);
  const toggleOpenDownloadTemplate = () =>
    setIsOpenDownloadTemplate(!isOpenDownloadTemplate);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const invoicePos = useSelector(state => state.invoicePos);
  const { type, fileDownload, fileDownloadName } = invoicePos;
  const { loading, items, totalCount, params } = invoicePos.listPhase;

  const history = useHistory();

  const { t, i18n } = useTranslation(["invoicePos"]);

  const [commonStatus, setCommonStatus] = useState(getPhaseInvoicePosStatus(t));

  const {
    isLoading: isLoadingDefaultFilter,
    isSuccess: isSuccessDefaultFilter,
    data: dataDefaultFilter,
    refetch: refetchDefaultFilter,
  } = useGetFilter(SCREEN_FILTER_CODE.PHASE_INVOICE_POS);

  useEffect(() => {
    setCommonStatus(getPhaseInvoicePosStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_INVOICE_POS_SUCCESS: {
        if (fileDownload !== null) {
          console.log(
            "🚀 ~ file: ListPhaseInvoicePos.js:112 ~ useEffect ~ fileDownload:",
            fileDownload
          );
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });

        dispatch(resetDownloadXmlInvoicePos());
        break;
      }
      case DOWNLOAD_XML_INVOICE_POS_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadXmlInvoicePos());
        break;
    }
  }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    buTenantHeaderInfo,
    tenantCodeHeader,
    buStoreHeader,
    finalBuInfo,
    listBuOfTenant,
  } = Dashboard;

  useEffect(() => {
    // K có quyền thì k dc vào menu MTT
    if (
      buStoreHeader &&
      tenantCodeHeader &&
      !checkIsHaveInvoicePos(
        buTenantHeaderInfo,
        finalBuInfo,
        buStoreHeader,
        tenantCodeHeader,
        listBuOfTenant
      )
    ) {
      // history.push("/pages-404");
      setIsUIRender(false);
    } else {
      setIsUIRender(true);
    }
  }, [finalBuInfo, buStoreHeader, tenantCodeHeader, listBuOfTenant]);

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      if (filterId) {
        params.columnFilter = {
          ...params.columnFilter,
          "filter[id]": filterId,
        };
      }
      dispatch(listPhaseInvoicePos(params));
    }
  }, [finalBuInfo]);

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    if (isSuccessDefaultFilter) {
      params.page = 1;
      params.sizePerPage = 10;
      initColumn(true);
      setTimeout(() => {
        if (filterId) {
          setDataDetail({
            id: filterId,
          });
          toggleViewDetailModal();
        }
        initColumn(false);
      });
    }
  }, [isSuccessDefaultFilter]);

  useEffect(() => {
    refetchDefaultFilter();
    return () => {
      dispatch(resetListPhaseInvoicePos());
    };
  }, []);

  const initColumn = loadDefaultFilter => {
    const columns = getInitColumns(loadDefaultFilter);
    let columnsVisibleInvoice = dataDefaultFilter?.columnsVisible;
    console.log(
      "🚀 ~ file: ListPhaseInvoicePos.js:134 ~ initColumn ~ columnsVisibleInvoice:",
      columnsVisibleInvoice
    );
    setColumns(formatHiddenColumn(columnsVisibleInvoice, columns));
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail(row);
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-download text-primary" />,
      text: "Download XML",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        let mltdiep = null;
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else {
          type = "tct-response";
          mltdiep = "204";
        }
        resource_id = getResourceIdXML(row.resource_list, type, mltdiep);
        if (resource_id) {
          dispatch(
            downloadXmlInvoicePos(
              resource_id,
              `INVOICE-BATCHES_${row.mst}__${row.id}`,
              "blob",
              TYPE_INVOICE_POS_ANOTHER.PHASE_INVOICE_POS
            )
          );
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
    {
      icon: <i className="bx bx-history text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    // {
    //   icon: <i className="bx bx-send font-size-20 text-success" />,
    //   text: "Phát hành lô hóa đơn",
    //   isShow: !modalDetail,
    //   conditionVisible: {
    //     can_release: [true],
    //     is_release: [0],
    //     auth_status: [AUTH_STATUS_APPROVE],
    //   },
    //   onClick: row => {
    //     openReleaseModal(row.id);
    //   },
    // },
    // {
    //   icon: <i className="fas fa-file-import font-size-20 text-info" />,
    //   text: "Import lô hóa đơn",
    //   isShow: !modalDetail,
    //   conditionVisible: {
    //     // can_release: [true],
    //     // is_release: [0],
    //     ["report.status"]: [AUTH_STATUS_WARNING, AUTH_STATUS_AR],
    //   },
    //   onClick: row => {
    //     dispatch(executeReport(row?.report_id));
    //   },
    // },
    // {
    //   icon: <i className="bx bx-download font-size-20 text-primary" />,
    //   text: "Download file đã import",
    //   isShow: !modalDetail,
    //   conditionVisible: {
    //     report_id: [],
    //   },
    //   onClick: row => {
    //     dispatch(
    //       downloadReportInvoice(
    //         row?.report_id,
    //         `LO_HOA_DON_${row?.code || ""}`
    //         //    +
    //         //   getTimeContent(row.parameters)
    //       )
    //     );
    //   },
    // },
  ];

  const openReleaseModal = id => {
    setIdRelease(id);
    toggleConfirmReleaseModal();
  };

  const getAuthStatus = row => {
    const { id, auth_status } = row;
    let infoError = null;
    if (auth_status === AUTH_STATUS_REJECT) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[auth_status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[auth_status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành"",
  };

  const getInitColumns = loadDefaultFilter => {
    return [
      {
        dataField: "id",
        text: "Id",
        sort: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          defaultValue: loadDefaultFilter ? filterId : undefined,
          style: { minWidth: "75px", maxWidth: "100px" },
        }),
      },
      {
        dataField: "mst",
        text: "MST",
        sort: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
        }),
        formatter: (cellContent, row) => (
          <div className="text-primary fw-bold">{cellContent}</div>
        ),
      },
      // {
      //   dataField: "code",
      //   text: "Mã lô",
      //   sort: true,
      // },
      {
        dataField: "auth_status",
        text: t("auth_status.name"),
        hidden: false,
        formatter: (cellContent, row) => getAuthStatus(row),
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: selectFilterAuthStatus,
        }),
      },
      {
        dataField: "checker_date",
        text: "Ngày cập nhật",
        hidden: false,
        formatter: (cellContent, row) => tableFormateDate(row.checker_date),
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={params.columnFilter}
          />
        ),
      },
    ];
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(listPhaseInvoicePos(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(listPhaseInvoicePos(params));
  };

  const optionShowColumnHandel = (field, value) => {
    let indexTargetColumn = columns.findIndex(item => item.dataField === field);
    if (indexTargetColumn > -1) {
      // Get column with defaultValuefilter
      const columnsWithFilter = getInitColumns(false).find(
        item => item.dataField === field
      );
      columnsWithFilter.hidden = !value;
      // Set lại cho default fitler cho column ẩn/hiện hiện tại
      columns[indexTargetColumn] = columnsWithFilter;
    }
    setColumns(columns);
    dispatch(setListPhaseInvoicePosColumn(field, value));
  };

  const resetDataFunc = () => {
    dispatch(listPhaseInvoicePos(params));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách đợt hóa đơn từ MTT</title>
        </MetaTags>
        <div className="container-fluid">
          {/* ErrorReleaseModal */}
          <ErrorReleaseModal
            isOpen={modalErrorRelease}
            toggle={toggleErrorReleaseModal}
            id={idRelease}
            path={"invoice-batches"}
          />
          {/* HistoryTransferModal */}
          <HistoryTransferModal
            isOpen={modalHistoryTransfer}
            toggle={toggleHistoryTransferModal}
            id={idHistory}
            path={"invoice-phase-pos"}
          />
          <DetailPhaseInvoicePos
            isOpenModal={modalDetail}
            phaseId={dataDetail?.id}
            mst={dataDetail?.mst}
            t={t}
            toggleModal={toggleViewDetailModal}
          />
          {isUIRender ? (
            <Row>
              <Breadcrumbs
                title=""
                breadcrumbItem={
                  "Danh sách đợt hóa đơn từ MTT" + ` (${totalCount})`
                }
              />
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <React.Fragment>
                      <RemoteDataTable
                        screenFilterCode={SCREEN_FILTER_CODE.PHASE_INVOICE_POS}
                        keyField="id"
                        data={items}
                        columns={columns || []}
                        page={params.page}
                        listRowAction={listRowAction}
                        sizePerPage={params.sizePerPage}
                        totalSize={totalCount}
                        loading={loading}
                        onTableChange={handleTableChange}
                        onSearchAllHandle={onSearchAllHandle}
                        optionShowColumnHandel={optionShowColumnHandel}
                        rowEvents={rowEvents}
                      ></RemoteDataTable>
                    </React.Fragment>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <div className="text-center text-danger font-size-20 font-weight-bold">
              Vui lòng chọn chi nhánh/đơn vị có cấu hình HĐ từ MTT
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListPhaseInvoicePos;
